module.exports = __webpack_public_path__ + "static/media/pdp_classicHover.f419db63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/pdp-hover/pdp_classicHover.jpg
// module id = 1007
// module chunks = 43